export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "data.worker.e7c6517935b9470f1e25.worker.js");
}
